function IsRoot() {
    return typeof window.isRoot === "undefined" || !window.hasOwnProperty("isRoot") || !window.isRoot
}
export default IsRoot;